import formatTableJson from '@manage/config/tableComponentParams.js'
export default formatTableJson([
  {
    filed: 'series',
    label: '设备类型'
  },
  {
    filed: 'model',
    label: '设备型号'
  },
  {
    filed: 'type',
    label: '温区',
    formatFn: function (_, row) {
      let dic = {
        '001u2qrwzlzysvkd': '单温区',
        '002u2qrwzlzysvkd': '双温区'
      }
      return dic[row.type]
    }
  },
  {
    filed: 'picture',
    label: '图片',
    type: 'image',
    needPreviewImg: true
  },
  {
    filed: 'remark',
    label: '备注'
  }
])
